import { render } from "./SuccessNotification.vue?vue&type=template&id=7518be2e"
import script from "./SuccessNotification.vue?vue&type=script&lang=js"
export * from "./SuccessNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__